// extracted by mini-css-extract-plugin
module.exports = {"date":"_08853a","dateIcon":"_c38153"};